// eslint-disable-next-line no-redeclare
/* global $ */

/**
 *
 * @author Ramon Kool, <ramon.kool@valtech.nl>
 * @version 1.0
 * @date november 2016
 */
class OtcModal {
    constructor() {}

    /**
     * initializes component
     */
    init() {
        $('.modal-close').text($('.modal').data('closetext'));
        $('.modal-close').on('click', function () {
            $(this).parent().removeClass('is-active'); //Direct parent, because modals don't have to have the modal close (this is done in CSS)
            $('.main-overlay').removeClass('is-active');
        });

        $('.dealersendlink').on('click', function () {
            $('.modal-send .modal-close').trigger('click');
        });
    }

    //Set the class for a specific modal, or set it to false and choose a specific text
    setModal(status, text, specificClass) {
        var $modal;

        if (specificClass !== undefined) {
            $modal = $('.modal-' + specificClass);
        } else {
            $modal = $('.modal');
        }

        if (status === true) {
            if (text !== false) $modal.find('.modal-text').text(text);
            $('.main-overlay').addClass('is-active');
            $modal.addClass('is-active');
        }

        if (status === false) {
            $('.main-overlay').removeClass('is-active');
            $modal.removeClass('is-active');
        }

        this.handleVirtualPageView(specificClass);
    }

    handleVirtualPageView(type) {
        const PageViewTypes = {
            send: {
                name: 'Send to dealer',
                page: 'send',
            },
            save: {
                name: 'Save & Share',
                page: 'save',
            },

            load: {
                name: 'Load',
                page: 'open',
            },
        };

        const pageView = PageViewTypes[type];

        if (pageView) {
            window.digitalData.triggerVirtualPageView({
                title: 'Truck configurator',
                ...pageView,
            });
        }
    }
}

export default OtcModal;
